import React, { PropsWithChildren, ReactElement } from "react";
import CustomCheckbox from "../CustomCheckbox";
import CustomSelect, { SelectOption } from "../CustomSelect";
import CustomRadio from "../CustomRadio"
import ErrorMsg from "../../../templates/Account_create_page/components/Form/ErrorMsg";
import styles from "./Form.module.scss"
import { closeBtn, closeBtnAlt } from "../../../shared/icons";

interface FormElementsFactoryProps {
    element: FormElement;
    withErrors?: boolean;
    handleInputChange: (e: any) => void;
    handleSelectChange: (name: string, value: string) => void;
    handleFormValidation: (e: any) => void;
    handleBlurValidation: (e: any) => void;
    formData: any;
    elements: any;
}

export interface FormElement {
    type: string;
    name: string;
    placeholder: string;
    data?: any;
    options?: SelectOption[];
    optional?: boolean;
    errorMessage?: string;
    hasRadio?: boolean;
    groupTraining?: boolean;
    isWhite: boolean;
}

export enum FormElementType {
    Select = "select",
    Text = "text",
    Email = "email",
    Tel = "tel",
    Textarea = "textarea",
    Checkbox = "checkbox",
    Radio = "radio",
    Number = "number"
}

const FormElementsFactory = (props: PropsWithChildren<FormElementsFactoryProps>): ReactElement => {
    const getOptionNeedId = () => {
        if (!props.formData.categories) return;
        const category = props.elements.find(e => e.name === "categories");
        const selectedCategory = props.formData.categories;
        const option = category.options.find(o => o.label === selectedCategory);
        return option.need_id;
    }

    const checkForceEmail = () => {
        if (props.element.name === "email" && props.withErrors || props.element.validations?.hasOwnProperty("skip")) {
            return (
                <CustomCheckbox
                    name={""}
                    label={"I confirm that this email is correct"}
                    handleChange={(e) => props.skipValidation("email", e.target.checked)}
                />
            )
        }
    }

    const setFormElement = () => {

        switch (props.element.type) {
            case FormElementType.Select:
                return (
                    <>
                        <CustomSelect
                            name={props.element.name}
                            options={props.element.options as SelectOption[]}
                            placeholder={props.element.placeholder}
                            handleChange={props.handleSelectChange}
                            isWhite={props.element.isWhite}
                            onBlur={props.handleBlurValidation}
                        />
                        {props.withErrors && <ErrorMsg errors={props.element.errorMessage} />}
                    </>
                );
            case FormElementType.Checkbox:
                return (
                    <>
                        <CustomCheckbox
                            name={props.element.name}
                            label={props.element.placeholder}
                            handleChange={props.handleInputChange}
                            onBlur={props.handleBlurValidation}
                        />
                        {props.withErrors && <ErrorMsg errors={props.withErrors} />}
                    </>
                );
            case FormElementType.Textarea:
                return (
                    <>
                        <textarea
                            name={props.element.name}
                            placeholder={props.element.placeholder}
                            onChange={props.handleInputChange}
                            onBlur={props.handleBlurValidation}
                        />
                        {props.withErrors && <ErrorMsg errors={props.withErrors} />}
                    </>
                );
            case FormElementType.Radio:
                return (
                    <>
                        <CustomRadio
                            name={props.element.name}
                            options={props.element.options as any[]}
                            handleChange={props.handleInputChange}
                            onBlur={props.handleBlurValidation}
                            groupTraining={props.element.groupTraining}
                        />
                        {props.withErrors && <ErrorMsg errors={props.withErrors} />}
                    </>
                );
            default:
                if (props.element.name === "member-id" && !getOptionNeedId() && props.formData["member-id"]) delete props.formData['member-id']
                return (
                    <>
                        {props.element.name === "try-class" && props.formData['try-class'] &&
                            <>
                            <button className={styles.tryClass} onClick={props.handleDeleteTryClass} >
                                <p>
                                    {props.formData['try-class']}
                                </p>
                                <span className={styles.closeTryClass}>{closeBtnAlt}</span>
                            </button>
                            </>
                        }
                        {props.element.name === "member-id" && getOptionNeedId() &&
                            <>
                                < input
                                    type={props.element.type}
                                    name={props.element.name}
                                    className={props.withErrors ? styles.hasErrors : ""}
                                    placeholder={props.element.placeholder}
                                    onInput={props.handleFormValidation}
                                    onChange={props.handleInputChange}
                                    onBlur={props.handleBlurValidation}
                                />
                                {props.withErrors && <ErrorMsg errors={props.withErrors} />}
                            </>
                        }
                        {props.element.name !== "member-id" && props.element.name !== "try-class" &&
                            <>
                                <input
                                    type={props.element.type}
                                    name={props.element.name}
                                    value={props.value || ""}
                                    className={props.withErrors ? styles.hasErrors : ""}
                                    placeholder={props.element.placeholder}
                                    onInput={props.handleFormValidation}
                                    onChange={props.handleInputChange}
                                    onBlur={props.handleBlurValidation}
                                />
                                {props.withErrors && <ErrorMsg errors={props.withErrors} />}
                            </>
                        }
                        {checkForceEmail()}
                    </>
                );
        }
    }

    return setFormElement();
}

export default FormElementsFactory;